module.exports = __webpack_public_path__ + "static/media/open_icon_black.efdceab7.svg";